import { render, staticRenderFns } from "./BaseItemClassification.vue?vue&type=template&id=473c4fba&scoped=true&"
import script from "./BaseItemClassification.vue?vue&type=script&lang=js&"
export * from "./BaseItemClassification.vue?vue&type=script&lang=js&"
import style0 from "./BaseItemClassification.vue?vue&type=style&index=0&id=473c4fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473c4fba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('473c4fba')) {
      api.createRecord('473c4fba', component.options)
    } else {
      api.reload('473c4fba', component.options)
    }
    module.hot.accept("./BaseItemClassification.vue?vue&type=template&id=473c4fba&scoped=true&", function () {
      api.rerender('473c4fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseItemClassification.vue"
export default component.exports